import {initWebComponent} from "@/helpers/web-component-helper";
import {
    getDataTableByFormIDAndFeatureID, getDataTableByPresentationIDAndDomainIDAndFormID,
    initDataTableStandAloneEditor
} from "@/helpers/datatable/datatable-standalone-editor-helper";
import {startLadda} from "@/helpers/ladda-helper";

export class LayerInfoInfoItemMutationStandaloneAddComponent extends HTMLElement {
    constructor(){
        super();
        const template = document.createElement('template');
        const domainID = this.getAttribute('data-domain-id')
        const presentationID = this.getAttribute('data-presentation-id')
        const formID = this.getAttribute('data-form-id')

        template.innerHTML = `
            <button data-spinner-color="#858380" class="btn btn-sm btn-outline-secondary icon-btn text-transform-none popper-header btnStandaloneEdit mr-1 ladda-button" href="#">
              <span class="fa fa-plus"></span>
              <div class="popper-tooltip" role="tooltip" data-popper-placement="bottom">
                 Object toevoegen
                <div class="arrow" data-popper-arrow=""></div>
              </div>
            </button>
`

        initWebComponent(this, template)

        this.addEventListener('click', () => {
            delete window.mutation_geom
            startLadda('.btnStandaloneEdit')
            initDataTableStandAloneEditor(getDataTableByPresentationIDAndDomainIDAndFormID(domainID, presentationID, formID), 'create', true)
        })
    }
}
